import { SvgIcon, SvgIconProps } from '@mui/material'
import { NovaColours, useAppContext } from '@novafuturltd/core'

export const BannerIcon = (props: SvgIconProps) => {
  const { mode } = useAppContext()
  const defaultFill = NovaColours.N040[mode]

  return (
    <SvgIcon {...props} viewBox="0 0 76 76">
      <path
        d="M18.9993 69.6663C17.2577 69.6663 15.7667 69.0462 14.5264 67.8059C13.2862 66.5656 12.666 65.0747 12.666 63.333V12.6663C12.666 10.9247 13.2862 9.4337 14.5264 8.19342C15.7667 6.95315 17.2577 6.33301 18.9993 6.33301H56.9994C58.741 6.33301 60.232 6.95315 61.4723 8.19342C62.7125 9.4337 63.3327 10.9247 63.3327 12.6663V63.333C63.3327 65.0747 62.7125 66.5656 61.4723 67.8059C60.232 69.0462 58.741 69.6663 56.9994 69.6663H18.9993ZM18.9993 63.333H56.9994V12.6663H18.9993V63.333ZM22.166 56.9997H53.8327L42.9077 42.7497L35.6243 52.2497L30.716 45.9163L22.166 56.9997Z"
        fill={defaultFill}
      />
    </SvgIcon>
  )
}

export default BannerIcon
